module.exports = __webpack_public_path__ + "static/media/big-laptop.401a8d60.jpg";